<template>
    <div class="bind-phone-page">
        <div>
            <img src="../../assets/logo.png" alt="" class="logo">
        </div>
        <div>
            <p class="title">请绑定您的手机号</p>
            <p class="desc">为保证账号安全及正常使用，依据相关法规政策要求，需要绑定手机号。</p>
        </div>
        <div class="input">
            <div class="phone-container phone-number">
                <div class="select-container">
                    <select :disabled="dialCodes.length <= 1" v-model="dialCode" class="qh">
                        <option
                            v-for="(item,index) in dialCodes"
                            :label="item.show_code"
                            :key="`${item.dial_code}_${index}`"
                            :value="item.dial_code"
                        >{{item.zh_name}}({{item.show_code}})</option>
                    </select>
                </div>
                <input v-model="phone" type="number" :maxlength="maxLength" pattern="[0-9]*" placeholder="请输入手机号"/>
            </div>
            <div class="phone-container">
                <input v-model="code" type="number" maxlength="6" pattern="[0-9]*" placeholder="请输入验证码"/>
                <a class="code-btn" @click="getCode">
                    <span v-show="isCountDown">
                        <Timer @cleared="isCountDown = false" @finished="isCountDown = false" ref="timer"/>s后重试
                    </span>
                    <span v-show="!isCountDown">获取验证码</span>
                </a>
            </div>
        </div>
        <div>
            <a :class="['btn', isPhoneValid && isCodeValid ? 'btn-primary' : 'btn-disable', 'bind-btn']" @click="bind">绑定</a>
        </div>
    </div>
</template>

<script>
import { verificationApi, userApi } from '@/apis'
import Cookie from '@/common/js/cookie'
import Timer from '@/components/Timer'

const REGEXP = {
    '0086': /^1[3456789]\d{9}$/, // 大陆
    '00852': /^5?[69]\d{7}$/, // 香港
    '00886': /^0?[23456789]\d{8}$/, // 台湾
    '00853': /^6\d{7}$/, // 澳门
    '001': /^\d{10}$/, // 加拿大、美国
    '0081': /^0?[89]0\d{7,8}$/, // 日本
    '0065': /^[89]\d{7}$/, // 西班牙
}
const MAXLENGTH = {
    '0086': 11,
    '00852': 9,
    '00886': 9,
    '00853': 8
}

export default {
    components: {
        Timer
    },
    data() {
        return {
            phone: '',
            code: '',
            codeSending: '',
            isCountDown: false,
            dialCode: '0086',

            dialCodes: [
                {dial_code: "0086", name: "China", show_code: "+86", zh_name: "中国"}
            ]
        }
    },
    computed: {
        isPhoneValid() {
            return (REGEXP[this.dialCode] || /\d{5,20}/).test(this.phone)
        },
        isCodeValid() {
            return /^\d{6}$/.test(this.code)
        },
        maxLength() {
            return MAXLENGTH[this.dialCode] || 20
        }
    },
    watch: {
        phone(newVal, oldVal) {
            if (isNaN(newVal)) this.phone = oldVal
            else this.phone = newVal.slice(0, this.maxLength)
        },
        code(newVal, oldVal) {
            if (isNaN(newVal)) this.code = oldVal
            else this.code = newVal.slice(0, 6)
        },
        qh(newVal) {
            console.log(newVal)
        }
    },
    methods: {
        async bind() {
            if (!this.isPhoneValid) {
                return this.$toast('手机号格式有误')
            }
            if (!this.isCodeValid) {
                return this.$toast('请输入六位数字验证码')
            }

            try {
                const { body: info } = await userApi.bindPhonePost({
                    body: {
                        phone: this.phone,
                        verify_code: this.code,
                        dial_code: this.dialCode
                    }
                })
                Cookie.set('uid', info.uid)
                Cookie.set('access_token', info.access_token, info.expires_in * 1000)
                Cookie.set('binded_phone', true)
                this.goBack()
            } catch(err) {
                this.$toast(err?.body?.message || '绑定失败')
                console.log('绑定失败', err)
            }
        },
        goBack() {
            const { query } = this.$route
            const successPath = query?.success ? new URL(query.success).pathname : '/'
            this.$router.replace({
                path: successPath
            })
        },
        async getCode() {
            if (this.isCountDown) return
            if (this.isPhoneValid) {
                try {
                    this.$refs.timer.countDown(60)
                    this.isCountDown = true
                    await verificationApi.verificationsPost({
                        body: {
                            phone: this.phone,
                            action_type: 'bind_phone',
                            dial_code: this.dialCode
                        }
                    })
                    this.$toast('已发送验证码，请注意查收短信')
                } catch(err) {
                    this.$refs.timer.clear()
                    this.$toast('验证码发送失败，请重试')
                }
            } else {
                this.$refs.timer.clear()
                this.$toast('请输入正确的手机号')
            }
        },
        async getDialCodes() {
            const { body: dialCodes } = await userApi.dialCodesGet()
            this.dialCodes = dialCodes
            console.log(dialCodes)
        }
    },
    mounted() {
        this.getDialCodes()
    }
}
</script>

<style lang="less" scoped>
.bind-phone-page {
    padding: 5rem 2.4rem 4rem;
    .logo {
        display: block;
        width: 5.4rem;
        height: 5.4rem;
        border-radius: 0.8rem;
        margin: 0 auto 5rem;
    }
    .title {
        font-size: @font-size-l;
        font-weight: bolder;
        margin-bottom: 1.2rem;
    }
    .desc {
        font-size: @font-size-sm;
    }
    .input {
        display: flex;
        flex-direction: column;
        padding: 3.2rem 0 4rem;
        .phone-container {
            height: 4.9rem;
            background-color: rgba(0, 0, 0, 0.03);
            border-radius: 0.2rem;
            padding: 0 1.7rem;
            display: flex;
            align-items: center;
            justify-content: space-around;
            &:last-child {
                margin-top: 1.2rem;
            }
            &.phone-number {
                background-color: transparent;
                padding: 0;
                .select-container {
                    // background-color: rgba(0, 0, 0, 0.03);
                    height: 100%;
                    border-right: 0.4rem solid #fff;
                    border-radius: 0.2rem;
                    position: relative;
                    &::after {
                        content: ' ';
                        display: block;
                        position: absolute;
                        top: calc(50% - 2.5px);
                        right: calc(1.6rem - 6px);
                        border-top: rgba(0, 0, 0, 0.6) 5px solid;
                        border-left: transparent 3px solid;
                        border-right: transparent 3px solid;
                        border-bottom: transparent 5px solid;
                    }
                }
                .qh {
                    border: none;
                    font-size: @font-size-l;
                    height: 100%;
                    width: 100%;
                    display: inline-block;
                    color: rgba(0, 0, 0, 0.6);
                    display: block;
                    -webkit-appearance: none;
                    appearance: none;
                    padding: 0 1.6rem;
                    background-color: rgba(0, 0, 0, 0.03);
                }
                input {
                    background-color: rgba(0, 0, 0, 0.03);
                    height: 100%;
                    border-radius: 4px;
                    padding-left: 1.6rem;
                }
            }
            input {
                margin: auto 0;
                flex: 1;
                font-size: @font-size-base;
                border: none;
                background-color: transparent;
                width: 100%;
                &::placeholder {
                    color: #B3B3B3;
                }
            }
            .code-btn {
                margin: auto 0;
                font-size: @font-size-xs;
                border: 1px solid #3355FF;
                border-radius: 0.2rem;
                padding: 0.6rem 0.8rem;
                flex-shrink: 0;
            }
        }
    }
    .bind-btn {
        font-size: @font-size-base;
        padding: 1rem 0;
    }
}
</style>
